export function getBedbankMemberTotalIncludingPropertyFees(rate: App.BedbankRate): number | undefined {
  const { memberInclusive, memberTotal, propertyFees } = rate.totals

  if (memberTotal != null) {
    return memberTotal
  }

  if (memberInclusive == null) {
    return undefined
  }

  return memberInclusive + (propertyFees ?? 0)
}

export function getBedbankValueIncludingPropertyFees(rate: App.BedbankRate): number {
  return rate.value + (rate.totals.propertyFees ?? 0)
}
